import io from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.connected = false;
  }

  async connect(token) {
    if (this.connected && this.socket) {
      console.log('Socket already connected');
      return Promise.resolve();
    }

    // Clean up existing socket if any
    if (this.socket) {
      console.log('Cleaning up existing socket');
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }

    const serverUrl = process.env.REACT_APP_API_URL;
    console.log('Connecting to socket server:', serverUrl);

    return new Promise((resolve, reject) => {
      try {
        this.socket = io(serverUrl, {
          auth: { token },
          reconnection: true,
          reconnectionDelay: 1000,
          reconnectionAttempts: 5,
          transports: ['websocket', 'polling']
        });

        this.socket.on('connect', () => {
          console.log('Socket connected with ID:', this.socket.id);
          this.connected = true;
          resolve();
        });

        this.socket.on('connect_error', (error) => {
          console.error('Socket connection error:', error);
          this.connected = false;
          this.socket = null;
          reject(error);
        });

        this.socket.on('disconnect', (reason) => {
          console.log('Socket disconnected:', reason);
          this.connected = false;
          
          // Add notification for user if disconnected due to new session
          if (reason === 'io server disconnect') {
            // You can use your preferred notification system here
            alert('You have been disconnected because you logged in from another location');
          }
        });
      } catch (error) {
        console.error('Socket initialization error:', error);
        this.socket = null;
        this.connected = false;
        reject(error);
      }
    });
  }

  isConnected() {
    return this.connected && this.socket?.connected;
  }

  disconnect() {
    console.log('Disconnecting socket');
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }

  emitUserConnected(userData) {
    if (!this.isConnected()) {
      console.error('Cannot emit userConnected - socket not connected');
      return false;
    }
    
    if (!userData?._id) {
      console.error('Invalid user data for socket connection');
      return false;
    }

    this.socket.emit('userConnected', userData);
    return true;
  }
}

// Create the instance
const socketService = new SocketService();

// Export the instance
export default socketService;
